<div class="atn-space-organization-assignments">
  <atn-ds-table [config]="tableConfig()" />
</div>

<!--
NOTE: The conditional rendering is intentionally placed in the parent,
not inside the modal component. This ensures the modal is recreated on each
open, so its constructor and initialization logic (default values, setup)
run every time.
-->
@if (
  recordAssignedOrgsEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal()
) {
  <atn-space-organization-assignment-modal />
}

@let isSubmitting =
  recordAssignedOrgsEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

@if (
  recordAssignedOrgsEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()
) {
  <atn-ds-confirmation-overlay
    title="Delete Organization Assignment"
    description="
      Deleting organization assignment can't be undone and also deletes its history. To keep the history, unassign it instead by turning off 'Is Occupier?'. Are you sure you want to delete this organization assignment?
    "
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    [loading]="isSubmitting"
    confirmButtonText="DELETE"
  />
}
